export const textChatMessageFactory = (text, isConsultant) => ({ payload: { text }, isConsultant, type: 'message' })
export const botTipsChatMessageFactory = (tips) => ({ payload: { tips }, isConsultant: true, type: 'tips' })
export const botTextChatMessageFactory = (text) => textChatMessageFactory(text, true)
export const userTextChatMessageFactory = (text) => textChatMessageFactory(text, false)
export const optionsFactory = (_options, onClick) => _options.map((o) => ({ ...o, onClick }))
